import { Link } from "react-router-dom";
import './DashboardPage.css';
import './PowerPointPage.css';

const PowerPointPage = (props) => {
    return (
        <div className="dashboard-container">
            <div className="dashboard-content-wrapper powerpoint-page-content">
                <div className="dashboard-section">
                    <h1 className="gradient-text text-center mb-4">Integrate Snorkle into your PowerPoint presentations</h1>

                    <p>Using the free Snorkle Viewer add-in for Microsoft PowerPoint, you can embed all supported Snorkle visuals and mobile-activating QR codes directly into your presentations. Because data items are loaded from the cloud, the actual files remain small even if you have massive amounts of data. While the add-in requires no account to get started, you must have a Snorkle account to access your personal or institutional library of visuals. Installation is just a few clicks. <a href="#compatibility">See here for version and operating system requirements.</a>
                    </p>
                    <a href="https://appsource.microsoft.com/en-us/product/office/wa200002840?src=snorkle-website&tab=overview" target="_blank" rel="noopener noreferrer">
                        <img src="https://snorkle-output-files.s3.amazonaws.com/snorkle-ppt-addin-downloadscreen.png" width="100%" alt="Snorkle PowerPoint Add-in Download Screen" />
                    </a>
                </div>

                <div className="dashboard-section">
                    <h4 className="text-white mb-3">A Note on Using Projectors</h4>
                    <p>If you are presenting PowerPoint live using an overhead projector and your slides utilize the Snorkle Viewer add-in, your computer's presentation mode must be set to display-mirroring mode. On a Mac, this option is available when you have started presentation mode, and in the presenter view you have the option to "use slide presentation." On a PC, go into display settings in presentation mode, and select duplicate slide show. Without taking these steps, the visuals may appear static on a projection screen and black on your computer screen.    
                    </p>
                </div>

                <div className="dashboard-section">
                    <h4 id="compatibility" className="text-white mb-3">Operating System Compatibility</h4>
                    <p>
                        <b>Note</b>: If you have difficulty installing the add-in or you do not see that option, <Link to="/contact#contact-form-top">contact us</Link> for assistance.
                    </p>
                    <p>
                        <b>Mac OS</b>: Requires PowerPoint version 16.19 or later versions including Office 365 (and web versions).
                    </p>
                    <p>
                        <b>Windows</b>: Requires PowerPoint 2019 and later, including Office 365 (and web version). Otherwise, requires The 32- or 64-bit version of Office 2013 or a later version, running on Windows 7 or a later version. Microsoft Edge must be installed, but doesn't have to be the default browser. 
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PowerPointPage;
